<div class="ui-input">
  @if (showLabel()) {
    <div class="ui-input__header">
      <label class="ui-input__label" [attr.for]="inputId()">{{ label() }}</label>
      @if (showRequirement()) {
        <span
          class="ui-input__requirement"
          [class.ui-input__requirement--error]="invalid() && required()"
          aria-hidden="true"
        >
          {{ requirementText() }}
        </span>
      }
    </div>
  }

  <div
    class="ui-input__field"
    [class.ui-input__field--invalid]="invalid()"
    [class.ui-input__field--disabled]="disabled()"
  >
    @if (kind() === 'search') {
      <span class="ui-input__search-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6.5" cy="6.5" r="4.5" stroke="currentColor" stroke-width="1.5"/>
          <path d="M10.5 10.5L14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </span>
    }

    <input
      class="ui-input__control"
      [class.ui-input__control--numeric]="isNumericKind()"
      [class.ui-input__control--has-suffix]="kind() === 'password'"
      [class.ui-input__control--has-prefix]="kind() === 'search'"
      [id]="inputId()"
      [attr.name]="name() ?? null"
      [attr.type]="nativeType()"
      [attr.inputmode]="inputModeAttr()"
      [attr.placeholder]="placeholder()"
      [attr.autocomplete]="autocomplete() ?? null"
      [attr.maxlength]="maxlength() ?? null"
      [attr.minlength]="minlength() ?? null"
      [attr.step]="step() ?? null"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-required]="required() ? 'true' : null"
      [attr.aria-describedby]="ariaDescribedBy()"
      [value]="displayValue()"
      (input)="onInput($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    />

    @if (kind() === 'password') {
      <button
        type="button"
        class="ui-input__pwd-toggle"
        [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
        [attr.aria-pressed]="showPassword()"
        [tabindex]="disabled() ? -1 : 0"
        (click)="togglePasswordVisibility()"
      >
        @if (showPassword()) {
          <!-- Ojo tachado: ocultar -->
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
            <path d="M2 2l14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M7.6 3.4A7.6 7.6 0 0 1 9 3.2c4.7 0 7.8 5.8 7.8 5.8a13.8 13.8 0 0 1-2.2 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M5.1 5.2A13.8 13.8 0 0 0 1.2 9S4.3 14.8 9 14.8a7.6 7.6 0 0 0 3.5-.9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M10.7 10.8a2.5 2.5 0 0 1-3.4-3.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        } @else {
          <!-- Ojo abierto: mostrar -->
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
            <path d="M1.2 9S4.3 3.2 9 3.2 16.8 9 16.8 9 13.7 14.8 9 14.8 1.2 9 1.2 9z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
            <circle cx="9" cy="9" r="2.5" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        }
      </button>
    }
  </div>

  @if (message() && invalid() && showMessage()) {
    <p
      class="ui-input__message"
      [id]="messageId()"
      [class.ui-input__message--error]="invalid()"
      [attr.role]="invalid() ? 'alert' : null"
    >
      {{ message() }}
    </p>
  }

  @if (showPasswordRulesList() || showPasswordMatchRule()) {
    <ul
      class="ui-input__password-rules"
      [id]="passwordRulesId()"
      aria-live="polite"
    >
      @if (showPasswordRulesList()) {
        <li
          class="ui-input__password-rule"
          [class.ui-input__password-rule--ok]="passwordHasMinLength()"
        >
          <span class="ui-input__password-rule-icon" aria-hidden="true">
            @if (passwordHasMinLength()) {
              ✓
            } @else {
              ○
            }
          </span>
          8 caracteres
        </li>
        <li
          class="ui-input__password-rule"
          [class.ui-input__password-rule--ok]="passwordIsAlphanumeric()"
        >
          <span class="ui-input__password-rule-icon" aria-hidden="true">
            @if (passwordIsAlphanumeric()) {
              ✓
            } @else {
              ○
            }
          </span>
          Alfanumérico
        </li>
        <li
          class="ui-input__password-rule"
          [class.ui-input__password-rule--ok]="passwordHasCasing()"
        >
          <span class="ui-input__password-rule-icon" aria-hidden="true">
            @if (passwordHasCasing()) {
              ✓
            } @else {
              ○
            }
          </span>
          Mayúsculas y minúsculas
        </li>
      }
      @if (showPasswordMatchRule()) {
        <li
          class="ui-input__password-rule"
          [class.ui-input__password-rule--ok]="passwordMatches()"
        >
          <span class="ui-input__password-rule-icon" aria-hidden="true">
            @if (passwordMatches()) {
              ✓
            } @else {
              ○
            }
          </span>
          Las contraseñas coinciden
        </li>
      }
    </ul>
  }
</div>
